import React, { useState } from "react";
import { useSelector } from "react-redux";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

// for page one

import ContractSetting from "./ContactSetting.jsx";
import ProjectPageOne from "./PageOne/Project.jsx";
import ContractDateDetails from "./PageOne/ContractDateDetails.jsx";
import ClientAndContractor from "./PageOne/ClientAndContractor.jsx";
import RestOne from "./PageOne/RestOne.jsx";

// for page two

import ProjectPageTwo from "./PageTwo/Project.jsx";
import Services from "./PageTwo/Services.jsx";
import BillingSchedules from "./PageTwo/BillingSchedules.jsx";

// for page three

import PageThree from "./PageThree/PageThree.jsx";

// for page four

import PageFour from "./PageFour/PageFour.jsx";

// for page five
import PageFive from "./PageFive/PageFive.jsx";

// for page six
import PageSix from "./PageSix/PageSix.jsx";

import TextStyles from "../../../../Constants/TextStyles";
import Styled from "./ReviewStyles";

import SignProposal from "../ProposalReviews/Signatures/SignProposal";
import AddClauseModal from "./PageModals/AddClauseModal";
import AddClause from "./AddClause/AddClause.jsx";
import ListAddClause from "./AddClause/components/ListAddClause";
import Colors from "../../../../Constants/Colors.js";
import { useHistory, useLocation } from "react-router-dom";
import { ReactTooltip } from "../../Commons/ReactTooltip.js";
import { useAllowedToContinue } from "../../../../hooks/useAllowedToContinue.js";

const Review = () => {
  const history = useHistory();
  const location = useLocation();
  const pathname =
    location && location.pathname.split("/").slice(0, -1).join("/");

  const { selectedData } = useSelector((state) => state.proposalAndContract);
  const [showSetting, setShowSetting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showAddClauseModal, setShowAddClauseModal] = useState(false);
  const isAllowed = useAllowedToContinue('contractClause');
  
  const showTooltip = !showSetting;

  const nextPageHandler = () => {
    if (
      (selectedData && selectedData.signature && selectedData.signature.text) ||
      (selectedData &&
        selectedData.signature &&
        selectedData.signature.image.image_name &&
        selectedData.signature.image.image_url)
    ) {
      history.push(`${pathname}/send`);
    } else {
      setShowModal(true);
    }
  };

  return (
    <div className="px-lg-4 px-md-4 px-sm-3 px-2">
      <div
        className="d-flex justify-content-center w-100"
        style={{ contain: "content" }}
      >
        <div
          className="w-100 p-3 p-sm-4 my-3 my-sm-4 bg-white"
          style={{ maxWidth: 800 }}
        >
          <Styled.ReviewBox className="mb-4">
            <div className="d-flex justify-content-between align-items-center gap-2">
              <TextStyles.FontSize22px className="fw-medium">
                Service Contract
              </TextStyles.FontSize22px>

              {showTooltip && (
                <ReactTooltip
                  anchorId="settings"
                  content="Contract Settings"
                  variant="grey"
                />
              )}
              <SettingsOutlinedIcon
                id="settings"
                sx={{ fontSize: 24, color: Colors.font2, cursor: "pointer" }}
                onClick={() => setShowSetting(true)}
              />
            </div>

            <div>
              <ProjectPageOne />
              <ContractDateDetails />
              <ClientAndContractor />
              <RestOne />
            </div>
          </Styled.ReviewBox>
          <Styled.ReviewBox className="mb-4">
            <TextStyles.FontSize22px className="three-dots fw-medium">
              Attachment A : Services
            </TextStyles.FontSize22px>
            <ProjectPageTwo />
            <Services />
            <BillingSchedules />
          </Styled.ReviewBox>
          <Styled.ReviewBox className="mb-4">
            <TextStyles.FontSize22px className="three-dots fw-medium">
              Attachment B : Terms and Conditions
            </TextStyles.FontSize22px>
            <PageThree />
          </Styled.ReviewBox>
          <Styled.ReviewBox className="mb-4">
            <PageFour />
          </Styled.ReviewBox>
          <Styled.ReviewBox className="mb-4">
            <PageFive />
          </Styled.ReviewBox>
          <Styled.ReviewBox className="mb-4">
            <PageSix />
          </Styled.ReviewBox>

          {selectedData &&
            selectedData.add_clause &&
            selectedData.add_clause.filter(
              (clause) => clause.required !== false
            ).length > 0 && (
              <Styled.ReviewBox className="mb-4 d-flex flex-column gap-4">
                {selectedData &&
                  selectedData.add_clause &&
                  selectedData.add_clause.map((data, index) => {
                    return (
                      <ListAddClause
                        key={index}
                        data={data}
                        pc_id={selectedData._id}
                      />
                    );
                  })}
              </Styled.ReviewBox>
            )}

          {!isAllowed && <ReactTooltip anchorId='add-clause' content='Upgrade Plan' variant='grey' />}
          <div id='add-clause' className={isAllowed ? '' : "opacity-75"} onClick={() => isAllowed ? setShowAddClauseModal(true) : {}}>
            <AddClause />
          </div>
        </div>
      </div>
      <Styled.SubmitButton onClick={nextPageHandler}>
        Continue
      </Styled.SubmitButton>
      {showSetting && (
        <ContractSetting
          show={showSetting}
          handleClose={() => setShowSetting(false)}
          selectedData={selectedData}
        />
      )}
      {showModal && (
        <SignProposal
          show={showModal}
          handleClose={() => setShowModal(false)}
          selectedData={selectedData}
        />
      )}
      {showAddClauseModal && (
        <AddClauseModal
          selectedData={selectedData}
          show={showAddClauseModal}
          handleClose={() => setShowAddClauseModal(false)}
        />
      )}
    </div>
  );
};

export default Review;
